import { History } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { api, ApiError } from '../api/client';
import type { SurveyDetail } from '../api/types';
import { AuditList } from '../components/AuditList';
import { SurveyHeader } from '../components/SurveyHeader';
import { PageLoader } from '../components/ui';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';

/** Activity tab: who changed, published, approved or exported this questionnaire. */
export function SurveyActivityPage() {
  const { id = '' } = useParams();
  const { t } = useI18n();
  const canAudit = useAuth().can('audit.view');
  const [survey, setSurvey] = useState<SurveyDetail | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getSurvey(id).then(setSurvey, (e) => setError(e instanceof ApiError ? e.message : t('common.load_failed')));
  }, [id, t]);

  if (error) return <div className="banner error">{error}</div>;
  if (!survey) return <PageLoader />;
  if (!survey.permissions.includes('survey.edit') && !canAudit) return <Navigate to={`/surveys/${id}/share`} replace />;

  return (
    <>
      <SurveyHeader
        id={survey.id}
        number={survey.number}
        code={survey.code}
        status={survey.status}
        permissions={survey.permissions}
        active="activity"
        title={<h1 className="ellipsis" style={{ fontSize: 26, fontWeight: 500 }}>{survey.title || t('common.untitled_questionnaire')}</h1>}
      />
      <div className="card">
        <div className="card-head">
          <div className="tile">
            <History />
          </div>
          <div className="grow">
            <h2>{t('audit.survey_title')}</h2>
            <div className="sub">{t('audit.survey_sub')}</div>
          </div>
        </div>
        <div className="card-pad" style={{ paddingTop: 0 }}>
          <AuditList load={(p) => api.surveyAudit(survey.id, p)} />
        </div>
      </div>
    </>
  );
}
